/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrOrgAuthProvider = 'UNKNOWN' | 'CSP' | 'AUTH_HUB' | 'NATIVE' | 'AWS' | 'GCP';

export const IrrOrgAuthProvider = {

    UNKNOWN: 'UNKNOWN' as IrrOrgAuthProvider,

    CSP: 'CSP' as IrrOrgAuthProvider,

    AUTH_HUB: 'AUTH_HUB' as IrrOrgAuthProvider,

    NATIVE: 'NATIVE' as IrrOrgAuthProvider,

    AWS: 'AWS' as IrrOrgAuthProvider,

    GCP: 'GCP' as IrrOrgAuthProvider
};

